'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Percent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @immutable
 */
var Percent = exports.Percent = function () {
    function Percent(value) {
        _classCallCheck(this, Percent);

        var percentValue = parseFloat(value, 10);

        if (_underscore2.default.isNaN(percentValue)) {
            throw new Error('percent can\'t be NaN');
        }

        // todo: restrict precision

        Object.defineProperty(this, 'value', {
            get: function get() {
                return percentValue;
            }
        });
        Object.preventExtensions(this);
    }

    _createClass(Percent, [{
        key: 'toJSON',
        value: function toJSON() {
            return this.value;
        }
    }]);

    return Percent;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas-common-models/dist/Percent.js
// module id = 1405
// module chunks = 118